import { ContentInfo } from './component';
import { Props } from './props';

export type ContentInfoProps = Props;

export * from './component';

export default ContentInfo;
